import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/button'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'
import ListArticlesTable from './components/listArticlesTable'

export const ListArticles = () => {
  const navigate = useNavigate()

  return (
    <Layout>
      <div className="flex flex-col gap-6">
        <div className="flex justify-between gap-4 items-center">
          <PageHeader title="Good Lists" className="!mb-0" />

          <Button
            label="Create good list"
            onClick={() => {
              navigate(`/lists/articles/create`)
            }}
            primary
            size="medium"
          />
        </div>

        <ListArticlesTable className="" />
      </div>
    </Layout>
  )
}
